(function() {
  const rangeSlider = document.getElementById('manuka-range');
  const products = document.querySelectorAll('.which-manuka-product');
  const descriptions = document.querySelectorAll('.range-line-description');
  const dots = document.querySelectorAll('.dots-container .dot');
  const arrow = document.querySelector('.manuka-slider .slider-wrapper .manuka-range-pointer');

  function updateDisplay(pos) {
    const value = parseInt(pos);
    const max = parseInt(rangeSlider.max);
    const min = parseInt(rangeSlider.min);
    const percent = (value - min) / (max - min) * 100;

    // Corrected formula for the background position
    rangeSlider.style.backgroundPosition = `${100 - percent}% 0`;

    arrow.style.left = `${percent}%`;

    // Update product and description
    const productId = products[[0, 1, 2, 3, 4][value]].dataset.product;

    products.forEach(prod => prod.classList.remove('active'));
    document.querySelector(`.which-manuka-product[data-product="${productId}"]`).classList.add('active');

    descriptions.forEach(desc => desc.classList.remove('active'));
    document.querySelector(`.range-line-description[data-product="${productId}"]`).classList.add('active');

    // Update dots: loop through all dots and apply logic
    dots.forEach((dot, index) => {
      if (index < value) {
        // Dot is to the left of the selected value
        dot.classList.add('active');
        dot.style.opacity = "1"; // show
      } else if (index === value) {
        // Dot is exactly under the thumb → hide it
        dot.style.opacity = "0";
      } else {
        // Dot is to the right
        dot.classList.remove('active');
        dot.style.opacity = "1"; // show
      }
    });

  }

  // Handle slider input
  rangeSlider.addEventListener('input', function() {
    updateDisplay(this.value);
  });

  // Initial state on page load
  updateDisplay(rangeSlider.value);
})();